import { formatRelativeTime, formatDateForTooltip } from "@/utils/dateUtils";

const DATE_RE =
  /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})?)?$/;

export function tryParseDate(value: string): Date | null {
  if (!DATE_RE.test(value)) return null;

  let normalized = value.replace(" ", "T");
  if (!normalized.includes("T")) {
    normalized += "T00:00:00Z";
  } else if (!/:\d{2}:\d{2}/.test(normalized)) {
    normalized = normalized.replace(/(T\d{2}:\d{2})/, "$1:00");
  }
  if (
    normalized.includes("T") &&
    !normalized.endsWith("Z") &&
    !/[+-]\d{2}:\d{2}$/.test(normalized)
  ) {
    normalized += "Z";
  }
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function tryFormatDate(value: string): string | null {
  const date = tryParseDate(value);
  if (!date) return null;
  return formatRelativeTime(date);
}

export function tryFormatDateTooltip(value: string): string | null {
  const date = tryParseDate(value);
  if (!date) return null;
  return formatDateForTooltip(date);
}
